<template>
  <div class="openDataIndex">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "openDataIndex"
};
</script>
<style lang="scss" scoped>
.caseIndex {
  height: 100%;
}
</style>
